import React, { useEffect, useState } from 'react'
import axios from "axios";

const UserManagement = () => {
  const [userDetails, setUserDetails] = useState(null);
  const getUsers = async (e) => {


    const config = {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",  // ✅ Add this header
      },
      withCredentials: true,  // ✅ Also add this for cookies
    };


    try {
      const response = await axios.get(
        `https://api.sankofagrid.com/api/v1/users/management`,
        config
      );
      setUserDetails(response?.data?.data);

    } catch (error) {

    }
  };

  useEffect(() => {
    getUsers()
  }, [])
  return (
    <div>UserManagement
      {userDetails && (
        <div>
          <h1>Total Attendees{userDetails?.totalAttendees}</h1>
          <h1>Total Deactivated Users{userDetails?.totalDeactivatedUsers}</h1>
          <h1>Total Organizers: {userDetails?.totalOrganizers}</h1>
          <table>
            <tr>
              <td>Id</td>
              <td>Full Name</td>
              <td>Email</td>
              <td>Role</td>
              <td>Status</td>
            </tr>
            {
              userDetails?.users?.content?.map((user) => {
                return (
                  <tr>
                    <td>{user?.id}</td>
                    <td>{user?.fullName}</td>
                    <td>{user?.email}</td>
                    <td>{user?.role}</td>
                    <td>{user?.status}</td>
                  </tr>
                )
              })
            }
          </table>
        </div>

      )}
    </div>
  )
}

export default UserManagement